import { createContext, useEffect, useState } from "react";

export const themeContext = createContext({
    theme: "light",
    setTheme: () => {}
})
export function ThemeProvider({ children }: any) {
  const [theme, setTheme] = useState<any>('light');
  const updateTheme = () => {
    document.body.classList.remove(theme);
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  }
  
  useEffect(() => {
    document.body.classList.add(theme);
  },[theme]);

  return (
    <themeContext.Provider value={{theme, setTheme: updateTheme}}>
        {children}
    </themeContext.Provider>
  )
}
